<template>
  <div>
    <VTextField
      v-model="data.name"
      :label="$t('forms.labels.standardFamily')"
      outlined
      :rules="{ required: true }"
      data-cy="standardFamily-name"
    />
    <VCheckbox
      v-if="isEdition"
      v-model="data.isTeamDefault"
      :label="$t('standardFamilies.labels.isTeamDefault')"
    />
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox';

export default {
    components: {
        VTextField,
        VCheckbox,
    },
    props: {
        standardFamily: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        data: {
            name: null,
        },
    }),
    watch: {
        data: {
            handler() {
                this.updateData();
            },
            deep: true,
        },
    },
    created() {
        if (this.isEdition) {
            this.data = this.standardFamily;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
